import { Fragment } from 'react';
import Image from 'next/image';
import { Box, Button, Input } from '@nerdwallet/currency';

import styles from './dynamic-image.module.scss';
import { useDynamicWpMedia } from './use-dynamic-wp-media';

const itemsPerPage = 21;

const Skeleton = ({ items }: { items: number }) => {
  return (
    <Fragment>
      {Array.from({ length: items }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className={styles.dynamicImageSkeleton} />
      ))}
    </Fragment>
  );
};

export const DynamicImageWpMedia = ({
  handleSelectImageSourceCallback,
}: {
  handleSelectImageSourceCallback: ({
    imageUrl,
    imageSource,
  }: {
    imageUrl?: string;
    imageSource?: string;
  }) => void;
}) => {
  const {
    inputSearchRef,
    handleSearch,
    handleNext,
    handlePrevious,
    handleImageClick,
    images,
    isLoading,
  } = useDynamicWpMedia({ handleSelectImageSourceCallback, itemsPerPage });

  return (
    <Fragment>
      <form onSubmit={handleSearch}>
        <Box display="flex" justifyContent="space-between" marginBottom={2}>
          <Input
            style={{ width: '100%' }}
            ref={inputSearchRef}
            type="text"
            placeholder="Search media"
          />
          <Button type="submit">Search</Button>
        </Box>
      </form>
      <div className={styles.dynamicImageListContainer}>
        {isLoading && <Skeleton items={itemsPerPage} />}

        {!isLoading &&
          images?.map((image: any) => (
            <button
              type="button"
              onClick={() => handleImageClick(image)}
              className={styles.dynamicImageListButton}
              key={image.id}
            >
              <div className={styles.dynamicImageListImageContainer}>
                <Image
                  blurDataURL={image?.media_details?.sizes?.mini?.source_url}
                  objectFit="cover"
                  src={image?.media_details?.sizes?.mini?.source_url}
                  alt={image.alt_text}
                  width={95}
                  height={95}
                />
              </div>
            </button>
          ))}
      </div>
      <Box
        display="flex"
        style={{ gap: '4px' }}
        justifyContent="space-between"
        paddingTop={2}
      >
        <Button onClick={handlePrevious}>Prev page</Button>
        <Button onClick={handleNext}>Next page</Button>
      </Box>
    </Fragment>
  );
};
